import AmpleHireImageTag from "../ample-hire-html-tags/ample-hire-image-tag";
import { image } from "../assets/assets";
import { FadeLoader } from "react-spinners";
import { useGlobalContext } from "../../context";

const AmpleHireLoader = () => {
  const { rootColor } = useGlobalContext();
  return (
    <div className="overlay">
      <div className="overlay__inner">
        <div className="overlay__content">
          <FadeLoader
            color={rootColor.primary}
            loading={true}
            size={60}
            aria-label="Loading Spinner"
            data-testid="loader"
            height={15}
            width={5}
            radius={1000}
            margin={6}
          />

          <AmpleHireImageTag
            className={"ample-hire-v-logo"}
            imgSrc={image.ampleHireVLogo}
            altText={"Loading..."}
          />
        </div>
      </div>
    </div>
  );
};

export default AmpleHireLoader;
